<template>

    <form @submit.prevent="sendForm">
        <div class="k-form__group">
            <label class="k-form__label" for="login">Uživatelské jméno</label>
            <input class="k-form__input k-form__input--lg" id="login" name="login" v-model="form.login" required>
            <field-error v-if="form_errors.login" >{{ form_errors.login[0] }}</field-error>
        </div>

        <div class="k-form__group">
            <label class="k-form__label" for="password">Heslo</label>
            <input class="k-form__input k-form__input--lg" id="password" type="password" name="password" v-model="form.password" required>
            <field-error v-if="form_errors.password" >{{ form_errors.password[0] }}</field-error>

            <!--<div class="text-right">
                <a class="k-login__forgotten-pass" href="#">Zapomenuté heslo?</a>
            </div>-->
        </div>

<!--
        <div class="k-form__group">
            <label class="k-form__label" for="remember">
                <input type="checkbox" name="remember" id="remember" value="1" v-model="form.remember">
                <div>Zapamatovat uživatele</div>
            </label>
            <field-error v-if="form_errors.remember" >{{ form_errors.remember[0] }}</field-error>
        </div> -->

        <div>
            <button class="k-btn k-btn--primary" type="submit">
                Přihlásit se
            </button>
        </div>

    </form>
</template>

<script>
    import FormBase from '../FormBase.vue';

    export default {
        extends: FormBase,

        data: () => ({
            form: {
                login: '',
                password: '',
                remember: ''
            },
        }),

        methods: {
            sendForm: async function() {
                let result = await this.sendData();
                if (result !== undefined && result.success === false) {
                    flash('Pokus o přihlášení se nezdařil.', 'danger');
                }
            }
        }
    }
</script>
